<template>
  <div class="text-dark text-decoration-none">
    <div class="card card-fidelidade">
      <router-link :to="{path: `${url}/promocoes`, query: {aba: 'clube'}}" class="d-flex text-dark align-items-center" v-if="componente">
        <icon name="pontos" size="24" class="text-primary" style="padding-right: 12px"/>
        <div>
          <h6 class="font-weight-bold mb-0">Clube de Vantagens</h6>
          <div class="text-muted small" v-if="token && pontos > 0">Oba! Você tem {{pontos}} ponto{{pontos !== 1 ? 's' : ''}}</div>
          <div class="text-muted small" v-else>Acumule pontos e troque por benefícios.</div>
        </div>
        <i class="fa fa-angle-right text-primary ml-auto"></i>
      </router-link>
      <div class="d-flex text-dark" v-else>
        <icon name="pontos" size="24" class="text-primary" style="padding-right: 12px; margin-top: 2px"/>
        <div>
          <h6 class="font-weight-bold mb-0">Clube de Vantagens</h6>
          <div class="text-muted small" v-if="token && pontos > 0">Saldo atual: <b>{{pontos}} ponto{{pontos !== 1 ? 's' : ''}}</b></div>
          <div class="text-muted small" v-else>Acumule pontos e troque por benefícios.</div>
        </div>
      </div>
      <div class="barra mt-2" :class="{'bloqueada': !pontos}">
        <div class="barra-titulo text-muted">
          <span>0 Pts</span>
          <span>30 Pts</span>
          <span>60 Pts</span>
          <span>90 Pts</span>
          <span>+120 Pts</span>
        </div>
        <div class="progresso" style="opacity: 0.5"></div>
        <div class="progresso progresso-pontos" :style="`width: ${progresso < 100 ? progresso : 100}%`"></div>
        <div class="ponto small" :style="`left: ${progresso < 100 ? progresso : 100}%; margin-left: ${progresso < 9 ? -4 : -24}px;`"><i class="fa fa-star"></i></div>
      </div>
      <div class="d-flex justify-content-center border-top pt-2 pb-1 small" v-if="token && !componente">
        <div class="w-50 pr-1">
          <router-link :to="url + '/perfil/meus-pontos'" class="d-block text-center text-secondary">
            <icon name="pedido" class="mr-1" size="16"/> Extrato de Pontos
          </router-link>
        </div>
        <div class="w-50 pl-1">
          <router-link :to="url + '/perfil/meus-vouchers'" class="d-block text-center text-secondary">
            <icon name="cupom" class="mr-1" size="16"/> Meus Vouchers
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from "./Icon";
export default {
  name: "ProgressoFidelidade",
  props: ['pontos', 'progresso', 'componente'],
  components: {Icon},
  data() {
    return {
      token: localStorage.getItem('token'),
    }
  },
  computed: {
    url() {
      return this.$store.state.url
    }
  }
}
</script>

<style scoped>
.barra {
  position: relative;
  height: 64px;
}

.barra-titulo {
  position: absolute;
  top: 0;
  font-size: 11px;
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.barra .progresso {
  width: 100%;
  height: 10px;
  background-color: var(--lecard-secondary);
  border-radius: 4px;
  position: absolute;
  top: 50%;
}

.barra .progresso-pontos {
  background-color: var(--lecard-primary);
  border-radius: 4px 0 0 4px;
  transition: 0.7s;
}

.barra .ponto {
  position: absolute;
  top: 35%;
  left: 0;
  width: 28px;
  height: 28px;
  font-weight: bold;
  background-color: var(--lecard-primary);
  border-radius: 50%;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.7s;
  margin-left: -24px;
}

.barra.bloqueada {
  opacity: 0.8;
}

.card-fidelidade {
  border: none;
  padding: 10px 14px;
  border-radius: 16px;
}
</style>
